export const DEFAULT_MAX_VISIBLE_PAGES = 5;

/**
 * The page numbers the pagination row renders between its arrows. Away from the ends the first and
 * last chips and their overflow menus join the row, so the window gives back the two slots they
 * take. Lower `maxVisiblePages` where the row has to fit a narrow container: at 3 the widest
 * arrangement is seven controls instead of eleven.
 */
export function getDisplayedPageNumbers({
  currentPage,
  totalPages,
  maxVisiblePages = DEFAULT_MAX_VISIBLE_PAGES,
  pageIsZeroIndexed = true,
}: {
  currentPage: number;
  totalPages: number;
  maxVisiblePages?: number;
  /**
   * Whether `currentPage` counts from zero. Callers that count from one have to say so, otherwise
   * the window centers on the page after the one the row highlights.
   */
  pageIsZeroIndexed?: boolean;
}) {
  const currentDisplayedPageNumber = pageIsZeroIndexed ? currentPage + 1 : currentPage;
  const innerWindow = Math.max(1, maxVisiblePages - 2);

  if (totalPages === 0) {
    return [1];
  }

  if (totalPages < maxVisiblePages) {
    return pageRange(1, totalPages);
  }

  if (currentDisplayedPageNumber < maxVisiblePages) {
    return pageRange(1, maxVisiblePages);
  }

  if (currentDisplayedPageNumber > totalPages - innerWindow) {
    return pageRange(totalPages - maxVisiblePages + 1, maxVisiblePages);
  }

  if (currentDisplayedPageNumber < totalPages) {
    return pageRange(currentDisplayedPageNumber - Math.floor(innerWindow / 2), innerWindow);
  }

  return pageRange(totalPages - maxVisiblePages + 1, maxVisiblePages);
}

function pageRange(start: number, length: number) {
  return Array.from({ length }, (_, index) => start + index);
}
